export const GET_ALL_SPORTS = "GET_ALL_SPORTS";
export const GET_ALL_SPORTS_RESPONSE_SUCCESS =
  "GET_ALL_SPORTS_RESPONSE_SUCCESS";
